import {messageTypeConfig, DELIVERY_TYPES} from './brandingConfig';
import type {DeliveryType, MessageType} from '../../../hooks/useBrandingParams';
import {eventPathHelper} from './brandingHelper';

export const getAllowedDeliveryTypes = (messageType: MessageType): DeliveryType[] =>
    messageTypeConfig[messageType]?.allowedDeliveryTypes ?? [DELIVERY_TYPES.email];

export const resolveDeliveryType = (messageType: MessageType, deliveryType: DeliveryType): DeliveryType => {
    const allowed = getAllowedDeliveryTypes(messageType);
    return allowed.includes(deliveryType) ? deliveryType : allowed[0];
};

export const buildBrandingPath = (
    eid: number | string,
    eventType: string,
    messageType: MessageType,
    deliveryType: DeliveryType,
): string => {
    const eventPath = eventPathHelper[eventType as keyof typeof eventPathHelper] ?? eventPathHelper.default;
    return `/e/${eid}/${eventPath}/branding/${messageType}/${deliveryType}`;
};

export function getBrandingPreviewProps(
    deliveryType: DeliveryType,
    compPreviewProps: Record<string, unknown> | undefined,
    messageType: MessageType,
    eventType: string,
    eid: number | string,
): Record<string, unknown> {
    const props = {...compPreviewProps};
    if(
        deliveryType === DELIVERY_TYPES.whatsapp
        && compPreviewProps
        && 'whatsappTemplate' in compPreviewProps
        && typeof compPreviewProps.whatsappTemplate === 'function'
    ) {
        props.whatsappTemplate = compPreviewProps.whatsappTemplate(messageType, eventType, eid);
    }
    return props;
}
